// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-box {
  width: 45px;
  height: 45px;
  margin: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 12px;
  overflow: hidden;
  background: #f7f7f7;
}
.image-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.image-box .placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}
.image-box ion-icon {
  font-size: 40px;
  color: #bbb;
  display: block;
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/pages/catalog-admin/components/catalog-tree/catalog-tree.component.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AADJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AAFJ;AAKE;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAHJ","sourcesContent":["\n.image-box {\n  width: 45px;\n  height: 45px;\n  margin: 3px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f7f7f7;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .placeholder {\n    text-align: center;\n    color: #888;\n    font-size: 14px;\n  }\n\n  ion-icon {\n    font-size: 40px;\n    color: #bbb;\n    display: block;\n    margin-bottom: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
